"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BreadcrumbsCC;
var _dropdown = _interopRequireWildcard(require("../dropdown/dropdown"));
var _react = _interopRequireWildcard(require("react"));
var _BreadcrumbsModule = _interopRequireDefault(require("./Breadcrumbs.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Breadcrumb = function Breadcrumb(_ref) {
  var title = _ref.title,
    link = _ref.link,
    desktopOnly = _ref.desktopOnly;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    className: (0, _classnames["default"])(_BreadcrumbsModule["default"].breadcrumb, desktopOnly ? _BreadcrumbsModule["default"].desktopOnly : null),
    children: [link ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      href: link,
      children: title
    }) : title, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _BreadcrumbsModule["default"].divider,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        width: "6",
        height: "10",
        viewBox: "0 0 6 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M1 1L5 5L1 9",
          stroke: "#767676",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    })]
  });
};
var BreadcrumbMenu = function BreadcrumbMenu(_ref2) {
  var breadcrumbs = _ref2.breadcrumbs;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDropdown = _useState2[0],
    setShowDropdown = _useState2[1];
  if (breadcrumbs.length <= 2) return null;
  var dropdownBreadcrumbs = breadcrumbs.slice(1, -1);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    className: (0, _classnames["default"])(_BreadcrumbsModule["default"].breadcrumb, _BreadcrumbsModule["default"].mobileOnly),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: _BreadcrumbsModule["default"].dropdownToggle,
      onClick: function onClick() {
        return setShowDropdown(!showDropdown);
      },
      children: "..."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _BreadcrumbsModule["default"].divider,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        width: "6",
        height: "10",
        viewBox: "0 0 6 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M1 1L5 5L1 9",
          stroke: "#767676",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdown["default"], {
      open: showDropdown,
      className: _BreadcrumbsModule["default"].dropdown,
      onClose: function onClose() {
        return setShowDropdown(false);
      },
      children: dropdownBreadcrumbs.map(function (breadcrumb, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdown.DropdownItem, {
          className: _BreadcrumbsModule["default"].dropdownItem,
          onClick: function onClick() {
            return window.open(breadcrumb.link, '_self');
          },
          children: breadcrumb.title
        }, "breadcrumbs-dropdown-item-".concat(index));
      })
    })]
  });
};
function BreadcrumbsCC(_ref3) {
  var breadcrumbs = _ref3.breadcrumbs,
    titleOverride = _ref3.titleOverride;
  var breadcrumbComponentList = breadcrumbs.map(function (breadcrumb, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Breadcrumb, {
      title: titleOverride && index === breadcrumbs.length - 1 ? titleOverride : breadcrumb.title,
      link: breadcrumb.link,
      desktopOnly: index === 0 || index === breadcrumbs.length - 1 ? false : true
    }, "breadcrumb-item-".concat(index));
  });
  breadcrumbComponentList.splice(1, 0, /*#__PURE__*/(0, _jsxRuntime.jsx)(BreadcrumbMenu, {
    breadcrumbs: breadcrumbs
  }, "bcmenu"));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _BreadcrumbsModule["default"].wrapper,
    "data-testid": "breadcrumbs",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _BreadcrumbsModule["default"].innerWrapper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        id: "breadcrumbs",
        className: _BreadcrumbsModule["default"].breadcrumbs,
        children: breadcrumbComponentList
      })
    })
  });
}